export type PaginationCompoundProps = {
  text?: string
  dataAnalytics?: string
}

export const PaginationCompound = (props: PaginationCompoundProps) => {
  return (
    <p
      className='u-textCenter u-paddingTop8 u-paddingBottom24'
      data-analytics={props?.dataAnalytics || ''}
    >
      {props?.text || ''}
    </p>
  )
}
